if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });

        /* ==========================================================================
          CUSTOM: Product Gallery - Hover Image Swap
          Added: 2026-06-06
          Search Tag: [CUSTOM_GALLERY_HOVER_SWAP]
          Status: ACTIVE
          ========================================================================== */

        this.bindHoverSwap();

        /*========================================================================== */

        /* ==========================================================================
          CUSTOM: Product Gallery - Variant Image Preload
          Added: 2026-06-10
          Search Tag: [CUSTOM_GALLERY_VARIANT_PRELOAD]
          Status: ACTIVE

          Purpose:
          - Warm browser cache for all gallery images
          - Reduce delay when switching colors
          - No changes to Dawn variant logic

          ========================================================================== */

        window.addEventListener('load', () => {
          document.querySelectorAll('.product__media img').forEach((img) => {
            const preload = new Image();
            preload.src = img.currentSrc || img.src;
          });
        });

        /*==========================================================================*/

        /* ==========================================================================
          CUSTOM: Product Gallery - Main Arrow Navigation
          Added: 2026-06-08
          Search Tag: [CUSTOM_GALLERY_MAIN_ARROW_NAVIGATION]
          Status: ACTIVE
          ========================================================================== */

        this.bindArrowNavigation();

        /*========================================================================== */

        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

        /* ==========================================================================
          CUSTOM: Product Gallery - Hover Image Swap Helper
          Added: 2026-06-06
          Search Tag: [CUSTOM_GALLERY_HOVER_SWAP]
          Status: ACTIVE
          ========================================================================== */
        bindHoverSwap() {
          if (!this.elements.thumbnails) return;

          this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {

            const button = mediaToSwitch.querySelector('button');

            /* ==========================================================================
              CUSTOM: Product Gallery - Hover Deduplication
              Added: 2026-06-10
              Search Tag: [CUSTOM_GALLERY_HARDENING]
              Component: [CUSTOM_GALLERY_HOVER_DEDUPLICATION]
              Status: ACTIVE
              ========================================================================== */
            if (!button || button.dataset.hoverSwapBound) return;
            button.dataset.hoverSwapBound = 'true';
            /*========================================================================== */

            button.dataset.hoverSwapBound = 'true';

            button.addEventListener('mouseenter', () => {
              button.click();
            });

          });
        }
        /*========================================================================== */
      
        /* ==========================================================================
          CUSTOM: Product Gallery - Main Arrow Navigation
          Added: 2026-06-08
          Search Tag: [CUSTOM_GALLERY_MAIN_ARROW_NAVIGATION]
          Status: ACTIVE
          ========================================================================== */
        bindArrowNavigation() {

          const prevArrow = this.querySelector('.custom-gallery-arrow--prev');
          const nextArrow = this.querySelector('.custom-gallery-arrow--next');

          if (!prevArrow || !nextArrow || !this.elements.thumbnails) return;

          const navigate = (direction) => {

            const thumbnails = [
              ...this.elements.thumbnails.querySelectorAll('[data-target]')
            ];

            const currentThumbnail = this.elements.thumbnails
              .querySelector('button[aria-current="true"]')
              ?.closest('[data-target]');

            if (!currentThumbnail) return;

            const currentIndex = thumbnails.indexOf(currentThumbnail);

            let nextIndex = currentIndex;

            if (direction === 'prev' && currentIndex > 0) {
              nextIndex = currentIndex - 1;
            }

            if (direction === 'next' && currentIndex < thumbnails.length - 1) {
              nextIndex = currentIndex + 1;
            }

            if (nextIndex === currentIndex) return;

            thumbnails[nextIndex].querySelector('button').click();

          };
          /* ==========================================================================
            CUSTOM: Product Gallery - Arrow Deduplication
            Added: 2026-06-10
            Search Tag: [CUSTOM_GALLERY_HARDENING]
            Component: [CUSTOM_GALLERY_ARROW_DEDUPLICATION]
            Status: ACTIVE
            ========================================================================== */
          if (!prevArrow.dataset.arrowBound) {
            prevArrow.dataset.arrowBound = 'true';
            prevArrow.addEventListener('click', () => navigate('prev'));
          }

          if (!nextArrow.dataset.arrowBound) {
            nextArrow.dataset.arrowBound = 'true';
            nextArrow.addEventListener('click', () => navigate('next'));
          }
          /*========================================================================== */

          this.updateArrowVisibility();

        }
        /*========================================================================== */

        /* ==========================================================================
        CUSTOM: Product Gallery - Main Arrow Visibility
        Added: 2026-06-08
        Search Tag: [CUSTOM_GALLERY_MAIN_ARROW_VISIBILITY]
        Status: ACTIVE
        ========================================================================== */
        updateArrowVisibility() {

          const prevArrow = this.querySelector('.custom-gallery-arrow--prev');
          const nextArrow = this.querySelector('.custom-gallery-arrow--next');

          if (!prevArrow || !nextArrow || !this.elements.thumbnails) return;

          const thumbnails = [
            ...this.elements.thumbnails.querySelectorAll('[data-target]')
          ];

          const currentThumbnail = this.elements.thumbnails
            .querySelector('button[aria-current="true"]')
            ?.closest('[data-target]');

          if (!currentThumbnail) return;

          const currentIndex = thumbnails.indexOf(currentThumbnail);

          prevArrow.classList.remove('is-hidden');
          nextArrow.classList.remove('is-hidden');

          if (currentIndex === 0) {
            prevArrow.classList.add('is-hidden');
          }

          if (currentIndex === thumbnails.length - 1) {
            nextArrow.classList.add('is-hidden');
          }

        }
        /*========================================================================== */

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            
            /* ==========================================================================
              CUSTOM: Product Gallery - Active Thumbnail Guard
              Added: 2026-06-10
              Search Tag: [CUSTOM_GALLERY_HARDENING]
              Component: [CUSTOM_GALLERY_ACTIVE_THUMBNAIL_GUARD]
              Status: ACTIVE
              ========================================================================== */
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);

            if (activeThumbnail) {
              this.setActiveThumbnail(activeThumbnail);
              this.announceLiveRegion(activeMedia,activeThumbnail.dataset.mediaPosition);
            }
            /*========================================================================== */
          }
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);

        /* ==========================================================================
          CUSTOM: Product Gallery - Main Arrow Visibility Refresh
          Added: 2026-06-08
          Search Tag: [CUSTOM_GALLERY_MAIN_ARROW_VISIBILITY]
          Status: ACTIVE
          ========================================================================== */
        this.updateArrowVisibility();
        /*========================================================================== */
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
